export const Marquee = ({ items, dark = true }) => {
  const list = [...items, ...items];
  return (
    <div
      className={`marquee overflow-hidden border-y ${dark ? "bg-slate border-white/10 text-white" : "bg-white border-line text-slate"} py-4`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track gap-10">
        {list.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-heading font-bold uppercase tracking-[0.12em] text-lg sm:text-xl whitespace-nowrap">
            {item}
            <span className="w-2 h-2 rounded-full bg-copper inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
